import { Dimension } from "../../../components/FileUploadComponent/constants";

export const FileUploadItems = [
	{
		key: "image",
		label: "Web Banner",
		dimensions: [{ width: 1905, height: 980 }] as Dimension[],
		maxFileSize: "20971520",
		extensions: ["jpeg", "jpg", "png"],
		isRequired: true,
		default: "imageUrl"
	},
	{
		key: "smallImage",
		label: "Web Banner Küçük",
		dimensions: [{ width: 585, height: 1080 }] as Dimension[],
		maxFileSize: "20971520",
		extensions: ["jpeg", "jpg", "png"],
		isRequired: true,
		default: "smallImageUrl"
	}
];


